import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si recién empiezo o si ya tengo años pedaleando?',
    a: 'Sí para los dos. El sistema está diseñado en capas. El ciclista nuevo encontrará todo lo que necesita para empezar bien desde el principio, sin cometer los errores que cuestan meses de progreso. El ciclista experimentado encontrará las técnicas avanzadas que le faltaban y el sistema de entrenamiento estructurado que explica por qué sus tiempos dejaron de mejorar hace meses.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al completar el pago, recibís un correo automático a tu dirección de email con el acceso inmediato a todos los PDFs. En menos de 5 minutos tenés los 6 Tomos y los 6 Bonos en tu celular o computadora. No hay nada que esperar ni que descargar de un sitio complicado.'
  }, {
    q: '¿Funciona para ruta y para MTB?',
    a: 'Sí. Cada tomo cubre específicamente los puntos donde ruta y MTB difieren. La mecánica, el Bike Fit, el entrenamiento, la técnica y el mantenimiento avanzado tienen secciones específicas para cada disciplina. Si pedaleás los dos estilos, el sistema cubre ambos sin comprar nada extra.'
  }, {
    q: '¿Necesito herramientas especiales o conocimiento previo?',
    a: 'No. El Tomo 1 empieza con el kit de herramientas mínimo necesario y su costo en Argentina. Los protocolos están explicados paso a paso con el lenguaje de un amigo que sabe de mecánica, no de un manual técnico de fábrica. Si podés apretar una llave Allen, podés hacer el 90% de lo que está en el sistema.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, devolución del 100%, sin preguntas y sin formularios. Escribís a soporte.tumanualdigital@gmail.com y listo. La tasa de devolución es menor al 1% porque el sistema funciona. Pero la garantía existe para que la decisión de compra sea completamente sin riesgo.'
  }, {
    q: '¿Puedo aplicarlo con solo 4-5 horas semanales de entrenamiento?',
    a: 'Sí. El Tomo 3 tiene un capítulo completo específico para el ciclista con 4-6 horas semanales disponibles. El Master-Plan 365 (en el upsell) está diseñado exactamente para integrar mecánica, entrenamiento y complementario en la semana de una persona con trabajo y familia. Menos tiempo no es excusa para no progresar con el método correcto.'
  }];
  return <section className="py-8 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-114">
      <FadeIn data-id="element-115">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-116">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(34,197,94,0.2)]" data-id="element-117">
            ❓
          </span>{' '}
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-4" data-id="element-118">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-119" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-white border-[#22c55e] shadow-[0_5px_15px_rgba(34,197,94,0.1)]' : 'bg-white border-[#e2e8f0] hover:border-[#22c55e]/50 shadow-sm'}`} data-id="element-120">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 md:px-6 py-4 md:py-6 text-left flex justify-between items-center focus:outline-none gap-3" data-id="element-121">
        <span className={`font-black text-sm md:text-xl pr-2 md:pr-4 transition-colors ${isOpen ? 'text-[#16a34a]' : 'text-[#0f172a]'}`} data-id="element-122">
          {question}
        </span>
        <div className={`shrink-0 p-1.5 md:p-2 rounded-full transition-colors ${isOpen ? 'bg-[#22c55e]/20 text-[#16a34a]' : 'bg-[#f1f5f9] text-[#475569]'}`} data-id="element-123">
          {isOpen ? <Minus className="w-4 h-4 md:w-5 md:h-5" data-id="element-124" /> : <Plus className="w-4 h-4 md:w-5 md:h-5" data-id="element-125" />}
        </div>
      </button>
      <AnimatePresence data-id="element-126">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-127">
            <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2" data-id="element-128">
              <p className="text-[#475569] leading-relaxed text-sm md:text-lg font-medium" data-id="element-129">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}